import Head from "next/head";

import ContactSupportMain from "@/components/contact/contact-support-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Support() {
  return (
    <>
      <Head>
        <title>{seoData.CONTACT_SUPPORT.title}</title>
        <SeoMetaData data={seoData.CONTACT_SUPPORT} />
      </Head>

      <ContactSupportMain />
    </>
  );
}
